var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44 .5H0v44h44V.5z",
    fill: "#EF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.532 21.45c-1.03-1.034-2.303-1.476-4.21-1.476h-4.086c-.748 0-1.155-.393-1.148-1.147v-2.213c-.006-.754.4-1.145 1.148-1.145h9.246v-5h-9.76c-3.614-.038-5.7 2.024-5.652 5.648v3.252c0 1.84.407 3 1.403 4 .99.992 2.191 1.417 4.02 1.417h4.297c.748 0 1.155.393 1.148 1.147v2.397c0 .383-.092.655-.291.854-.205.206-.46.294-.854.294h-12.98l-2.645-4.34c2.976-.036 4.755-1.776 4.695-4.824v-4.18c0-1.924-.423-3.133-1.462-4.176-1.03-1.034-2.283-1.49-4.19-1.49H5.141v23.998h5.072V15.47H15.7c.383 0 .655.092.854.291.206.205.294.46.294.854v3.062c.006.753-.399 1.146-1.148 1.145-1.576.036-3.12-.293-4.047 1.188-.691 1.077-.442 2.614.224 3.679l4.579 8.136c.229.407.658.642 1.178.642h15.708c3.624.049 5.686-2.039 5.652-5.652v-3.188c0-1.924-.424-3.134-1.462-4.177z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h44v44H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsLogo);
export default __webpack_public_path__ + "static/media/rs-logo.5f99f71048a083c92c97df1b75f58d90.svg";
export { ForwardRef as ReactComponent };